
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    inject,
    Renderer2,
    ViewChild,
} from '@angular/core';
import { GridComponent } from '../grid/grid.component';
import { IConfig, IDynamicElement } from '../_shared/models';

interface ILeadooInpageBotConfig extends IConfig {
    botCode: string;
}

@Component({
    selector: 'sirius-leadoo-inpage-bot',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './leadoo-inpage-bot.component.scss',
    imports: [GridComponent],
    template: '<sirius-grid><div #containerEl></div></sirius-grid>'
})
export class LeadooInpageBotComponent implements AfterViewInit, IDynamicElement {
    config?: ILeadooInpageBotConfig;

    @ViewChild('containerEl')
    private _containerRef!: ElementRef<HTMLElement>;
    private _renderer = inject(Renderer2);

    ngAfterViewInit(): void {
        const botCode = this.config?.botCode;
        if (!botCode) {
            console.error('Invalid configuration. Bot code is required.');

            return;
        }

        setTimeout(() => {
            const scriptEl: HTMLScriptElement = this._renderer.createElement('script');
            scriptEl.type = 'text/javascript';
            scriptEl.src = `https://bot.leadoo.com/bot/inpage.js?code=${botCode}#seamless`;

            this._renderer.appendChild(this._containerRef.nativeElement, scriptEl);
        }, 500);
    }
}
